import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './Fields.module.css';

/**
 * Internal wrapper to handle input state
 *
 * @param name
 * @param id
 * @param label
 * @param value
 * @param checked
 * @param props
 * @returns {*}
 * @constructor
 */
const Input = ({ field, id, label, value, checked, ...props }) => {
  return (
    <div>
      <Field name={field?.name} id={id} value={value} checked={checked} {...props} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

/**
 * Standard text input field
 *
 * @param id
 * @param label
 * @param name
 * @returns {*}
 * @constructor
 */
const TextInput = ({ id, label, name }) => {
  return (
    <div key={id}>
      {label && <label>{label}</label>}
      <Field component={'text'} name={name} />
    </div>
  );
};

/**
 * List of options for a select input
 *
 * @param values
 * @returns {*}
 * @constructor
 */
const SelectOptions = ({ values }) => {
  const options = values.map((option) => {
    return (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    );
  });

  return <>{options}</>;
};

/**
 * Radio button
 *
 * @param value
 * @param id
 * @param props
 * @returns {*}
 * @constructor
 */
/*const RadioButton = ({ field: { value }, id, ...props }) => {
  console.log(id, value);
  return <Input checked={id === value} value={id} type="radio" {...props} />;
};*/

const RadioButton = ({ field: { name, value, onChange, onBlur }, id, label, className, ...props }) => {
  return (
    <div className={styles.radio}>
      <input
        name={name}
        id={id}
        className={className}
        type="radio"
        value={id} // could be something else for output?
        checked={id === value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

/**
 * Checkbox
 *
 * @param value
 * @param props
 * @returns {*}
 * @constructor
 */
/*const CheckBox = ({ field: { value }, ...props }) => {
  return <Input type="checkbox" checked={value} value={value} {...props} />;
};*/

const CheckBox = ({ field: { name, value, onChange, onBlur }, id, label, className }) => {
  const hasHtml = label.indexOf('<') > -1;
  return (
    <div className={styles.grid}>
      <div>
        <input
          name={name}
          id={id}
          type="checkbox"
          value={value}
          checked={value}
          onChange={onChange}
          onBlur={onBlur}
          className={className}
        />
      </div>
      {hasHtml && <div className={styles.label} dangerouslySetInnerHTML={{ __html: label }} />}
      {!hasHtml && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
};

const sharedPropTypes = {
  field: PropTypes.object.isRequired,
  id: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.string,
};

Input.propTypes = { ...sharedPropTypes };
TextInput.propTypes = { ...sharedPropTypes };
RadioButton.propTypes = { checked: PropTypes.bool, ...sharedPropTypes };
CheckBox.propTypes = { checked: PropTypes.bool, ...sharedPropTypes };
SelectOptions.propTypes = {
  values: PropTypes.array.isRequired,
};

export { TextInput, SelectOptions, RadioButton, CheckBox };
